import { GrowthBook } from "@growthbook/growthbook-react";
import logger from "./logger";

const growthbook = new GrowthBook({
  apiHost: "https://cdn.growthbook.io",
  clientKey: "sdk-cMF7lt7fTfSE3Um",
  enableDevMode: true,
  // Enable URL targeting for easy preview of variations
  enableUrlOverride: true,
  trackingCallback: (experiment, result) => {
    // Track experiments to Google Analytics 4
    if (typeof window !== "undefined" && window.gtag) {
      window.gtag("event", "experiment_viewed", {
        experiment_id: experiment.key,
        variation_id: result.variationId,
        variation_value: result.value,
      });
    }
    logger.log("Experiment Viewed", {
      experimentId: experiment.key,
      variationId: result.variationId,
      value: result.value,
    });
  },
});

export default growthbook;
